import ko from 'knockout';
import _ from 'lodash';
import reviewObj from './reviewObj';
import reviewUtil from './reviewUtil';
import jobUtil from './jobUtil';
import moment from 'moment';

export default class jobObj {

  constructor(data) {

    console.log("jobObj:constructor:data: %o", data);
    this.componentname = "jobObj";

    this.rowVisible = ko.observable(true);
    this.editorVisible = ko.observable(false);
    this.editorComponent = ko.observable("job-edit");
    this.timelineComponent = ko.observable();
    this.isDirty = ko.observableArray(false);

    //this.data = data;

    this.title = ko.observable(data.title);
    this.body = ko.observable("");


    this.datecreated = ko.observable(moment(data.datecreated.replace('Z', '')).format('MMM D, YYYY h:mm A'));
    this.datelastused = ko.observable(moment(data.datelastused.replace('Z', '')).format('MMM D, YYYY h:mm A'));


    this.jobid = ko.observable(data.jobid);

    this.statusid = ko.observable(data.statusid);
    this.subid = ko.observable(data.subid);
    this.subparentid = ko.observable(data.subparentid);
    this.partnerid = ko.observable(data.partnerid);

    this.jobguid = ko.observable(data.jobguid);

    this.optionColumn1 = ko.observable(data.optionColumn1);
    this.optionColumn1Label = ko.observable(data.optionColumn1Label);

    this.optionColumn2 = ko.observable(data.optionColumn2);
    this.optionColumn2Label = ko.observable(data.optionColumn2Label);

    this.optionColumn3 = ko.observable(data.optionColumn3);
    this.optionColumn3Label = ko.observable(data.optionColumn3Label);

    this.optionColumn4 = ko.observable(data.optionColumn4);
    this.optionColumn4Label = ko.observable(data.optionColumn4Label);

    this.optionColumn5 = ko.observable(data.optionColumn5);
    this.optionColumn5Label = ko.observable(data.optionColumn5Label);

    this.optionColumn6 = ko.observable(data.optionColumn6);
    this.optionColumn6Label = ko.observable(data.optionColumn6Label);

    this.workflowArray = ko.observableArray().extend({
      notify: 'always'
    });

    this.statusName = ko.computed(function () {

      switch (this.statusid()) {
        case 0:
          return "Editing";
          break;
        case 1:
          return "inActive";
          break;
        case 2:
          return "In Review";
          break;
        case 3:
          return "Approved";
          break;
        case 9:
          return "Stopped";
          break;
        default:
          return "InActive";
      }

    }, this);

    this.init(data);

    console.log("jobObj:constructorComplete:data: %o", this);

  }

  init(data) {

  }

  validate(context) {

    if (typeof this.subid() === 'undefined' || this.subid() === null) {
      this.subid(context.subid());
    }

    if (typeof this.subparentid() === 'undefined' || this.subparentid() === null) {
      this.subparentid(context.subparentid());
    }
  }


  updateJobData(data) {

    console.log("jobObj:updateJobData:data: %o", data);

    this.datecreated(moment(data.datecreated).format('MMM D, YYYY h:mm A'));
    this.datelastused(moment(data.datelastused).format('MMM D, YYYY h:mm A'));

    this.statusid(data.statusid);

    this.optionColumn1(data.optionColumn1);
    this.optionColumn1Label(data.optionColumn1Label);

    this.optionColumn2(data.optionColumn2);
    this.optionColumn2Label(data.optionColumn2Label);

    this.optionColumn3(data.optionColumn3);
    this.optionColumn3Label(data.optionColumn3Label);

    this.optionColumn4(data.optionColumn4);
    this.optionColumn4Label(data.optionColumn4Label);

    this.optionColumn5(data.optionColumn5);
    this.optionColumn5Label(data.optionColumn5Label);

    this.optionColumn6(data.optionColumn6);
    this.optionColumn6Label(data.optionColumn6Label);

  }


  /* Review and Approve Workflow Functions */
  getWorkflows(context) {
    console.log("jobObj: getWorkflows");
    this.getReviewData(context);
  }



  getReviewData(context) {

    this.workflowArray([]);
    let self = this;
    let reviewUtlObj = new reviewUtil(context);

    console.log("jobObj:getReviewData: jobid: %o", this);

    reviewUtlObj.getReviewForJob(this.jobid()).then((result) => {
      console.log(result);
      ko.utils.arrayForEach(result.data, function (item) {
        console.log(item);
        self.workflowArray.push(new reviewObj(item));
        self.workflowArray.valueHasMutated();
      });

      self.workflowArray.valueHasMutated();
      console.log(self.workflowArray());
      //alert(self.workflowArray().length);
      return;
    });

  }

  getNextReviewSortNumber() {

    let returnNumber = 0;

    console.log("getNextReviewSortNumber");

    console.log(this.workflowArray());

    ko.utils.arrayForEach(this.workflowArray(), function (item) {
      console.log(item);
      if (item.sort() >= returnNumber) {
        console.log(item.sort());
        returnNumber = item.sort() + 1;
      }
    });

    console.log("getNextReviewSortNumber: return");
    console.log(returnNumber);

    return returnNumber;

  }

  // Workflow Procedures
  deleteWorkflow(id) {

    console.log("jobobj:deleteWorkflow");
    console.log(id);

    for (var i = 0, len = this.workflowArray().length; i < len; i++) {
      if (this.workflowArray()[i].id() === id) {
        this.workflowArray.remove(this.workflowArray()[i]);
        console.log("Deleted Item");
        return;
      }
    }
  }

  addWorkflow(worklowItem) {

    console.log("jobObj: addWorkflow");
    this.workflowArray().push(worklowItem);

    this.workflowArray.valueHasMutated();

    console.log(this.workflowArray());
  }

  startReview(context) {

    console.log("startReview");
    let self = this;
    let reviewUtlObj = new reviewUtil(context);

    return new Promise((resolve, reject) => {
      console.log("reviewUtlObj");
      console.log(reviewUtlObj);
      reviewUtlObj.startReview(this.jobid()).then((response) => {
        console.log("startReview: response");
        self.getReviewData(context);
        return true;
      }).catch((errror) => {
        console.log("getReviewForJob Error:");
        console.log("error");
        return;
      });

    });
  }

  stopReview(context) {

    console.log("stopReview");
    let self = this;
    let reviewUtlObj = new reviewUtil(context);

    return new Promise((resolve, reject) => {
      console.log("reviewUtlObj");
      console.log(reviewUtlObj);
      reviewUtlObj.stopReview(this.jobid()).then((response) => {
        self.getReviewData(context);
        return true;
      }).catch((errror) => {
        console.log("stopReview Error:");
        console.log("error");
        return;
      });

    });

  }

  refreshThisJob(context) {

    let jobUtilSrv = new jobUtil(context);
    jobUtilSrv.getJob({
      jobid: this.jobid(),
      subid: this.subid()
    }).then(response => {
      console.log('jobObj:refreshThisJob ****** job: %o', response);
      this.updateJobData(response.data[0]);
    })
  }


}

//export let  subTopicObj = new subTopicObjModel();


// WEBPACK FOOTER //
// ./src/objects/jobObj.js